export default "__VITE_ASSET__CgBdQDk7__"